// -------------------------------------
// Alerts
// -------------------------------------
(function($) {

  $(document).ready(function() {

    // Dismissable alerts
    $(".alert").alert();

  });

})(jQuery);